import { render, staticRenderFns } from "./HeaderText.vue?vue&type=template&id=69e03e92&scoped=true&"
import script from "./HeaderText.vue?vue&type=script&lang=js&"
export * from "./HeaderText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e03e92",
  null
  
)

export default component.exports